import { tradeNotes } from '../api/client';

/**
 * Capture the chart canvas as a PNG Blob.
 * @param {React.RefObject|HTMLElement} containerRef - ref to the chart container div
 * @returns {Promise<Blob|null>}
 */
export function captureChart(containerRef) {
  return new Promise((resolve) => {
    try {
      const container = containerRef?.current || containerRef;
      if (!container) {
        resolve(null);
        return;
      }
      const canvas = container.querySelector('canvas');
      if (!canvas) {
        console.warn('chartCapture: no canvas found in container');
        resolve(null);
        return;
      }
      canvas.toBlob(
        (blob) => resolve(blob),
        'image/jpeg',
        0.85
      );
    } catch (err) {
      console.error('chartCapture: capture failed', err);
      resolve(null);
    }
  });
}

/**
 * Capture the chart and upload as a TradeNote screenshot.
 * Fire-and-forget: never throws, never blocks trading.
 * @param {React.RefObject} containerRef
 * @param {number|string} sessionId
 * @param {number|string} tradeId
 * @param {string} label - e.g. "Entry", "Exit", "Exit - Stop Loss"
 */
export async function captureAndUpload(containerRef, sessionId, tradeId, label) {
  try {
    if (!tradeId) return;

    // Small delay to let the chart render the latest bar
    await new Promise((r) => requestAnimationFrame(r));

    const blob = await captureChart(containerRef);
    if (!blob) return;

    const formData = new FormData();
    formData.append('note_type', 'screenshot');
    formData.append('content', label);
    formData.append('image', blob, `chart_${tradeId}_${label.replace(/\s+/g, '_')}_${Date.now()}.jpg`);

    await tradeNotes.create(sessionId, tradeId, formData);
  } catch (err) {
    console.error('chartCapture: upload failed', err);
  }
}
